import { EventAggregator } from "aurelia-event-aggregator";
import { autoinject } from "aurelia-framework";

import { config } from "../../common/config";
import { EnumsService } from "../../services/enums-service";
import { LookupService } from "../../services/lookup-service";

@autoinject
export class AppCache {
    private _enumsService: EnumsService;
    private _lookupService: LookupService;
    private _cacheRefreshMap: Map<string, () => void> = new Map([
        [config.enumCacheKey, this.refreshEnums.bind(this)],
        [config.stateListCacheKey, this.refreshStateListData.bind(this)],
        [config.countryListCacheKey, this.refreshCountryListData.bind(this)],
        [config.countryPhoneCodeListCacheKey, this.refreshCountryPhoneCodeData.bind(this)]
    ]);
    public enumsRefreshed: boolean = false;

    public constructor(enumsService: EnumsService, ea: EventAggregator,
        lookupService: LookupService) {
        this._enumsService = enumsService;
        this._lookupService = lookupService;
    }

    public async refreshCache() {
        this.clearCache();
        this._cacheRefreshMap.forEach((refreshMethod, cacheKey) => refreshMethod());
    }

    public async restoreMissingCache() {
        this.enumsRefreshed = false;
        this._cacheRefreshMap.forEach((refreshMethod, cacheKey) => {
            let isEntityCached = !!localStorage.getItem(cacheKey);
            if (!isEntityCached) {
                refreshMethod();
            }
        });
        // If we did not refresh all enums, at least refresh the account/user dependent ones
        if (!this.enumsRefreshed) {
            await this._enumsService.getFeatureToggleableEnums();
        }
    }

    private clearCache() {
        this._enumsService.clearCachedEnums();
        localStorage.removeItem(config.stateListCacheKey);
    }

    private async refreshEnums() {
        await this._enumsService.getAllEnums();
        this.enumsRefreshed = true;
    }

    private async refreshStateListData() {
        localStorage.removeItem(config.stateListCacheKey);
        await this._lookupService.getAmericanStateCodes();
    }

    private async refreshCountryListData() {
        localStorage.removeItem(config.countryListCacheKey);
        await this._lookupService.getCountryCodes();
    }

    private async refreshCountryPhoneCodeData() {
        localStorage.removeItem(config.countryPhoneCodeListCacheKey);
        await this._lookupService.getCountryPhoneCodes();
    }
}
